export default {
    dashboard: 'ダッシュボード',
};